import React, { useCallback, useEffect, useState } from "react";
import { CloudUpload, Edit2, X, Trash2, Plus, Info } from "lucide-react";
import UploadBtn, { UploadStatus } from "./uploadSurplus";
import AddOfferModal from "./AddOffer";
import { useOptimizerNavigation } from "../utility/useOptimizerNavigation";
import {
  getStatusTraderOffersData,
  StartSimulationProcurementData,
} from "../../../../Rest_api/RestApi";
import TimeInput from "../../../../components/TimeInput/TimeInput";

function SurplusDeficitForm({
  refreshKey,
  setRefreshKey,
}: {
  refreshKey: any;
  setRefreshKey: any;
}) {
  const { navigateToPage } = useOptimizerNavigation();
  const [surplusDeficitUploaded, setSurplusDeficitUploaded] = useState(false);
  const [selectedScenario, setSelectedScenario] = useState("");
  const [uploadStatus, setUploadStatus] = useState<UploadStatus>("pending");
  const [tradeAdded, setTradeAdded] = useState(false);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUploadSuccess = (fileName: string) => {
    setFileName(fileName);
    setUploadStatus("submitted");
    setSurplusDeficitUploaded(true);
  };
  const handleTradeAdded = () => {
    setTradeAdded(true);
  };

  const handleStartSimulation = async () => {
    setLoading(true);
    const data = {
      surplusDeficit: uploadStatus,
      mcpScenario: selectedScenario,
      traderOffers: tradeAdded,
    };
    const res = await StartSimulationProcurementData(data);
    if (res) {
      navigateToPage("simulation");
      setLoading(false);
    }
  };

  // Check if all requirements are met
  const isSimulationEnabled =
    surplusDeficitUploaded && selectedScenario !== "" && tradeAdded;
const fetchOffers = useCallback (async () => {
   
      const statusPower = await getStatusTraderOffersData();
        if(statusPower){
          const mcp = statusPower?.mcpScenario;
          const surplus = statusPower?.surplusDeficit;
          const trade = statusPower?.traderOffers;
          setUploadStatus(surplus);
          setSelectedScenario(mcp);
          setTradeAdded(trade);
          if (surplus === true) {
            setSurplusDeficitUploaded(true);
            setUploadStatus("submitted");
          }

        }
      
    }
  , []);
  // Load offers on mount
  useEffect(() => {     
    fetchOffers();
  }, [fetchOffers, refreshKey]);

  useEffect(() => {
    if (refreshKey > 0) {
      // setSelectedScenario("");
      // setUploadStatus("pending");
    }
  }, [refreshKey]);
  return (
    <div className="w-full h-full bg-white px-3 py-3 !bg-[#F5F7FA]">
      <div className="w-full h-full mx-auto space-y-4">
        {/* Surplus Deficit Section */}

        <UploadBtn
          modalTitle="Surplus Deficit Upload"
          uploadStatus={uploadStatus}
          uploadedFileName={fileName}
          onUploadSuccess={handleUploadSuccess}
        />
        {/* MCP Scenario Section */}
        <div className="bg-[#FFFFFF] rounded-2xl border-[2px] border-[#CAD5E2] px-6 py-4">
          <div className="flex items-center justify-between">
            <span className="text-[#6F6D7C] text-lg font-medium">
              Choose Market Price Method
            </span>
            <div className="relative w-80">
              <select
                value={selectedScenario}
                onChange={(e) => setSelectedScenario(e.target.value)}
                className="w-[100%] !h-[50px] py-1 px-4 pr-10 border border-gray-200 rounded-xl text-2xl text-[#8C8A96] font-medium bg-white appearance-none outline-none cursor-pointer"
              >
                <option value="">Select Scenario</option>
                 <option value="1">Last Year</option>
                  <option value="2">Last 2 Year Avg</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-[-1px] top-[-3px] flex items-center pr-[10px] text-[#9AA0A6]">
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        {/* Add trader */}
        <AddOfferModal
          onOfferAdded={handleTradeAdded}
          refreshKey={refreshKey}
          setRefreshKey={setRefreshKey}
        />

        {/* Start Simulation Button */}
        <div className="flex justify-center">
          <button
            onClick={handleStartSimulation}
            disabled={!isSimulationEnabled}
            className={`px-8 py-3 rounded-2xl text-xl font-medium border transition-colors shadow-sm ${
              isSimulationEnabled
                ? "bg-[#F1935C] text-white border-[#F1935C] hover:bg-white hover:text-[#F1935C] cursor-pointer"
                : "bg-gray-300 text-gray-500 border-gray-300 cursor-not-allowed opacity-50"
            }`}
          >
            {loading ? "Loading..." : "Start Simulation"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SurplusDeficitForm;
